import { client_domain } from "@/main.js";
import { HOME_FEATURE_ICONS } from "@/utils/home_feature_icons";

export default {
  mounted() {
    this.initSidebar();
    if (client_domain.includes('cbo')) {
      this.cbo_domain = true

    }
  },
  props: {
    isSidebarOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return ({
      cbo_domain: false,
      menu_items: [
        {
          href: "/organisation",
          icon: HOME_FEATURE_ICONS.portals,
          default_label: "Portals",
          cbo_label: "Memberships",
        },
        {
          href: "/view_group",
          icon: HOME_FEATURE_ICONS.groups,
          default_label: "Groups",
        },
        {
          href: "/view_events",
          icon: HOME_FEATURE_ICONS.events,
          default_label: "Events",
        },
      ],
    });
  },
  computed: {
    sidebar_menu_items() {
      return this.menu_items.map(item => ({
        ...item,
        label: this.cbo_domain && item.cbo_label ? item.cbo_label : item.default_label,
        icon: this.cbo_domain && item.cbo_label ? HOME_FEATURE_ICONS.memberships : item.icon,
      }));
    },
  },
  methods: {
    initSidebar() {
      let arrows = document.querySelectorAll(".arrow");
      arrows.forEach(arrow => {
        arrow.addEventListener("click", (e) => {
          let arrowParent = e.target.parentElement.parentElement;
          arrowParent.classList.toggle("show-menu");
        });
      });
    },

  }
}
